import React from "react";

/**
 * Global ambient background — persistent behind all pages.
 * Fixed position, pointer-events none, behind main content (z-index 0 / main has z-index 10+).
 *
 * Composition:
 *   • 3 large colored blobs (cyan/emerald/amber) drifting slowly
 *   • Subtle grid overlay (8% opacity lines)
 *   • Radial vignette for depth focus
 *   • Noise texture for premium finish
 */
export default function BackgroundFx() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 overflow-hidden pointer-events-none z-0"
      data-testid="background-fx"
    >
      {/* Layer 1 — Subtle colored blobs (discreet accents, preserve readability) */}
      <div className="absolute -top-32 -left-32 w-[700px] h-[700px] rounded-full bg-cyan-500/15 blur-[120px] animate-blob-1" />
      <div className="absolute top-1/4 -right-40 w-[620px] h-[620px] rounded-full bg-emerald-500/12 blur-[120px] animate-blob-2" />
      <div className="absolute top-[10%] left-[45%] w-[450px] h-[450px] rounded-full bg-violet-500/10 blur-[130px] animate-blob-1" />

      {/* Layer 2 — Fine grid pattern (primary visual identity) */}
      <div
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,240,255,0.95) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,240,255,0.95) 1px, transparent 1px)
          `,
          backgroundSize: "54px 54px",
        }}
      />

      {/* Layer 3 — Radial vignette (restores deep black on edges) */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 25%, rgba(5,5,10,0.85) 100%)",
        }}
      />

      {/* Layer 4 — Noise texture (premium grain) */}
      <div
        className="absolute inset-0 opacity-[0.05] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='200' height='200' filter='url(%23n)' opacity='1'/></svg>\")",
        }}
      />
    </div>
  );
}
